import { cloneDeep } from 'lodash'

export const convertRewardToSection = reward => ({
    id: reward.id,
    resultHeader: reward.name,
})
const getMappedStatistic = (sections, statistic) => {
    const existedIds = sections.map(section => section.id)
    const filteredStatistic = statistic.filter(({ sectionId }) => existedIds.includes(sectionId))

    const totalUsers = filteredStatistic.reduce((acc, section) => acc + section.users, 0)

    return sections.map(section => {
        let stat = filteredStatistic.find(stat => stat.sectionId === section.id) || { users: 0, percent: 0 }

        stat.percent = stat.users ? Math.round(100 / (totalUsers / stat.users)) : 0

        return {
            ...section,
            ...stat,
        }
    })
}

export const getMappedStatisticBySections = (statistic, blockProjection) => {
    if (statistic.blockId !== blockProjection.blockId) return []

    const sections = cloneDeep(blockProjection.metadata.sections)

    return getMappedStatistic(sections, statistic.wheelSections)
}

export const getMappedStatisticByRewards = (statistic, rewardsProjection) => {
    if (!rewardsProjection) return []

    const sections = cloneDeep(rewardsProjection.list).map(reward => convertRewardToSection(reward))

    return getMappedStatistic(sections, statistic.wheelSections)
}
